import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
//@ts-ignore
import styled from "./styles/MenuWrapper.module.css";

import MenuBusinessSection from "../menuBusinessSection/MenuBusinessSection";
import MenuUserActionSection from "../menuUserActionSection/MenuUserActionSection";

import {
  CalendarIcon,
  CashRegisterStrokeIcon,
  SiteIcon,
  PeopleIcon,
} from "../../models/icons";

import FooterButton from "../FooterButton/FooterButton";
import { hasModuleAccess } from "@/utils/shared/permissions/hasModuleAccess";
import { useMultiSedeStore } from "../../../../stores/useMultiSedeStore";
import { useOnboardingStore } from "../../../onboarding/stores/useOnboardingStore";
import OnboardingModule from "../../../onboarding/OnboardingModule";
// Modal global de permisos: escucha el evento "access-denied" disparado por
// validateAccess. Debe vivir en el layout siempre montado.
// @ts-ignore
import ModalAccessDenied from "../ModalAccessDenied/ModalAccessDenied";
// Spec 007: bloqueo por suscripción vencida (escucha "subscription-expired")
// y banner de pago pendiente durante el período de gracia.
import SubscriptionBlocked from "../../../../components/SubscriptionBlocked/SubscriptionBlocked";
import GraceBanner from "../../../../components/GraceBanner/GraceBanner";
import PlanLimitPrompt from "../../../../components/PlanLimitPrompt/PlanLimitPrompt";
import PlanFeatureLocked from "../../../../components/PlanFeatureLocked/PlanFeatureLocked";
import GlobalCheckoutHost from "../../../../components/GlobalCheckoutHost/GlobalCheckoutHost";
import useSubscriptionGate from "../../../../hooks/useSubscriptionGate";

const MenuWrapper = () => {
  // Paywall al entrar: si la cuenta está vencida, el overlay de bloqueo se
  // muestra de inmediato en vez de esperar a que falle una llamada.
  useSubscriptionGate();

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [loginWarnings, setLoginWarnings] = useState<string[]>([]);
  const initializeMultiSede = useMultiSedeStore((s) => s.initialize);
  const initializeOnboarding = useOnboardingStore((s) => s.initialize);

  useEffect(() => {
    initializeMultiSede();
    initializeOnboarding();
    // Mostrar warnings del login (ej: sede sin horarios)
    try {
      const raw = localStorage.getItem("login_warnings");
      if (raw) {
        setLoginWarnings(JSON.parse(raw));
        localStorage.removeItem("login_warnings");
      }
    } catch {}
  }, [initializeMultiSede, initializeOnboarding]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className={styled.menuWrapper__container}>
      <OnboardingModule />
      <nav className={styled.menuWrapper__navegation}>
        <section className={styled.menuWrapper__navegation__section}>
          <MenuBusinessSection />
          <MenuUserActionSection />
        </section>
      </nav>
      <main className={styled.menuWrapper__content__scroll}>
        <GraceBanner />
        {loginWarnings.length > 0 && (
          <div style={{
            background: "#fef3c7", borderBottom: "1px solid #f59e0b", padding: "10px 24px",
            display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12,
            fontSize: 14, color: "#92400e", fontWeight: 500,
          }}>
            <div>
              {loginWarnings.map((w, i) => <span key={i}>{w}</span>)}
            </div>
            <button
              onClick={() => setLoginWarnings([])}
              style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#92400e", fontWeight: 700, padding: "0 4px" }}
            >
              ×
            </button>
          </div>
        )}
        <section className={styled.menuWrapper__main__section}>
          <Outlet />
        </section>
      </main>
      {screenWidth < 900 && (
        <footer className={styled.navigation__footer}>
          <section className={styled.navigation__footer__content}>
            {hasModuleAccess("f363f59b-20e8-481d-83d1-72231191fbf3") && (
              <FooterButton
                icon={CashRegisterStrokeIcon}
                label={"Cajas"}
                redirectTo={"/cajas"}
                accessId="f363f59b-20e8-481d-83d1-72231191fbf3"
              />
            )}
            {hasModuleAccess("48bc617b-199b-4f25-9b15-d84da7be03b3") && (
              <FooterButton
                icon={CalendarIcon}
                label={"Reservas"}
                redirectTo={"/reservas"}
                accessId="48bc617b-199b-4f25-9b15-d84da7be03b3"
              />
            )}
            {hasModuleAccess("2e5bb676-f25c-4cd3-8897-de15782f37ba") && (
              <FooterButton
                icon={PeopleIcon}
                label={"Clientes"}
                redirectTo={"/clientes"}
                accessId="2e5bb676-f25c-4cd3-8897-de15782f37ba"
              />
            )}
            {hasModuleAccess("73d1b54a-3293-4325-9838-13beef01fa60") && (
              <FooterButton
                icon={SiteIcon}
                label={"Estadísticas"}
                redirectTo={"/estadisticas"}
                accessId="73d1b54a-3293-4325-9838-13beef01fa60"
              />
            )}
          </section>
        </footer>
      )}
      <ModalAccessDenied />
      <SubscriptionBlocked />
      <PlanLimitPrompt />
      <PlanFeatureLocked />
      <GlobalCheckoutHost />
    </div>
  );
};

export default MenuWrapper;
